import { render, staticRenderFns } from "./freepeople.vue?vue&type=template&id=bf385b0e&scoped=true"
import script from "./freepeople.vue?vue&type=script&lang=js"
export * from "./freepeople.vue?vue&type=script&lang=js"
import style0 from "./freepeople.vue?vue&type=style&index=0&id=bf385b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf385b0e",
  null
  
)

export default component.exports